import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface DashboardCounterSkeletonProps {
  height?: number;
}

export const DashboardCounterSkeleton: React.FC<DashboardCounterSkeletonProps> = ({
  height = 120,
}) => {

  return (
    <Box
      sx={{
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        p: 4,
        height,
      }}
    >
      {/* Title */}
      <Skeleton variant="text" width="40%" sx={{ fontSize: '1rem' }} />
      {/* Value */}
      <Skeleton variant="text" width="50%" sx={{ fontSize: '3rem', pt: 3 }} />
    </Box>
  );
};
